const testIds = {
  root: 'description-root',
  descriptionSeeButton: 'description-see-button',
  seeButton: 'description-seeButton',
};

export default testIds;
